import axios from "axios";

export default axios.create({
  baseURL: "https://sleepy-oasis-40898.herokuapp.com/api/",
});
